import http from '../httpConfig';
import { TenantInfo, ValidateDomainRequest } from '../interfaces/tenant.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { LOCAL_STORAGE_KEYS } from '../utils/appConstant';
import { encryptData, decryptData } from '../utils/methods';

const validateDomain = async (payload: ValidateDomainRequest) => {
  return await http.post(API_ENDPOINTS.tenantValidate, payload);
};

const storeTenantInfo = (tenantInfo: TenantInfo) => {
  const encrypted = encryptData(tenantInfo);
  localStorage.setItem(LOCAL_STORAGE_KEYS.tenantInfo, encrypted);
};

const getTenantInfo = (): TenantInfo | null => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.tenantInfo);
  return data ? decryptData(data) : null;
};

const clearTenantInfo = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.tenantInfo);
};

const TenantService = {
  validateDomain,
  storeTenantInfo,
  getTenantInfo,
  clearTenantInfo,
};

export default TenantService;
